import React from 'react';
type Tone = 'dark' | 'light' | 'grey';
interface SectionShellProps {
  number: string;
  title: string;
  tone: Tone;
  eyebrow?: string;
  children: React.ReactNode;
}
const toneStyles: Record<Tone, {
  wrap: string;
  number: string;
  title: string;
  rule: string;
}> = {
  dark: {
    wrap: 'bg-ink text-white',
    number: 'text-white/35',
    title: 'text-white',
    rule: 'accent-rule'
  },
  light: {
    wrap: 'bg-white text-ink',
    number: 'text-ink/30',
    title: 'text-ink',
    rule: 'accent-rule'
  },
  grey: {
    wrap: 'bg-paper-grey text-ink',
    number: 'text-ink/30',
    title: 'text-ink',
    rule: 'accent-rule'
  }
};
export function SectionShell({
  number,
  title,
  tone,
  eyebrow,
  children
}: SectionShellProps) {
  const s = toneStyles[tone];
  return <section id={`section-${number}`} className={`w-full scroll-mt-0 ${s.wrap}`} aria-labelledby={`heading-${number}`} data-id="element-120" data-mp="7eqrquushuam">
      <div className="mx-auto w-[1200px] px-24 py-28" data-id="element-121" data-mp="ccs8380tzfie">
        <div className={`h-[3px] w-28 ${s.rule}`} aria-hidden="true" data-id="element-122" data-mp="223kpjuinonjl" />
        <header className="mt-8 flex items-baseline gap-8" data-id="element-123" data-mp="221rem310fh5s">
          <span className={`font-display text-6xl font-semibold tabular-nums tracking-tightest ${s.number}`} data-id="element-124" data-mp="1y0xttiiv6ih4">
            {number}
          </span>
          <h2 id={`heading-${number}`} className={`font-display text-5xl font-semibold tracking-tightest ${s.title}`} data-id="element-125" data-mp="2bvi5tfoiu5p6">
            {title}
          </h2>
        </header>
        {eyebrow ? <p className={`mt-6 max-w-3xl text-lg leading-relaxed ${tone === 'dark' ? 'text-white/70' : 'text-ink/70'}`} data-id="element-126" data-mp="1f3ekseweozup">
            {eyebrow}
          </p> : null}
        <div className="mt-16" data-id="element-127" data-mp="1o2rsb20yzecs">{children}</div>
      </div>
    </section>;
}